import { render, staticRenderFns } from "./WheelGame.vue?vue&type=template&id=2ca046e8&scoped=true"
import script from "./WheelGame.vue?vue&type=script&lang=js"
export * from "./WheelGame.vue?vue&type=script&lang=js"
import style0 from "./WheelGame.vue?vue&type=style&index=0&id=2ca046e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca046e8",
  null
  
)

export default component.exports